// extracted by mini-css-extract-plugin
export const footer = "Footer-module--footer--2andl";
export const footerContainer = "Footer-module--footerContainer--3mNe6";
export const socialList = "Footer-module--socialList--aJ_Fw";
export const icon = "Footer-module--icon--1kIgn";
export const companyInfo = "Footer-module--companyInfo--2WXPw";
export const linkList = "Footer-module--linkList--3rYsd";